class ExpDeliveryTimer extends HTMLElement {
  constructor() {
    super();
    this.cutOffTime = "18:00:00";
    this.timer = null;
    this.serverNow = null;
  }

  connectedCallback() {
    const currentTimeAttr = this.getAttribute('data-current-date-time');
    if (currentTimeAttr) {
      this.serverNow = new Date(currentTimeAttr);
    } else {
      this.serverNow = new Date(); // fallback
    }
    this.startTimer();
  }

  startTimer() {
    const cutOffArray = this.cutOffTime.split(":");
    const todayCutOffPoint = new Date(this.serverNow);
    todayCutOffPoint.setHours(cutOffArray[0], cutOffArray[1], cutOffArray[2], 0);

    this.timer = setInterval(() => {
      this.serverNow = new Date(this.serverNow.getTime() + 1000); // tick from server time
      this.updateCountdown(todayCutOffPoint);
    }, 1000);

    this.updateCountdown(todayCutOffPoint); // initial call
  }

  updateCountdown(todayCutOffPoint) {
    const now = this.serverNow;
    let deliveryTime;

    const setDeliveryTime = (daysToAdd) => {
      const d = new Date(now);
      d.setDate(d.getDate() + daysToAdd);
      d.setHours(16, 0, 0, 0);
      return d;
    };

    const day = now.getDay();
    const afterCutoff = now > todayCutOffPoint;

    if (day === 5 && afterCutoff) {
      deliveryTime = setDeliveryTime(3); // Friday after cut-off -> Monday
    } else if (day === 6) {
      deliveryTime = setDeliveryTime(2); // Saturday -> Monday
    } else if (day === 0) {
      deliveryTime = setDeliveryTime(1); // Sunday -> Monday
    } else if (afterCutoff) {
      deliveryTime = setDeliveryTime(1); // Weekday after cut-off -> next day
    } else {
      deliveryTime = todayCutOffPoint; // Same-day delivery
    }

    const difference = deliveryTime - now;

    let seconds = Math.floor(difference / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);

    hours %= 24;
    minutes %= 60;
    seconds %= 60;

    let output =
      days > 0
        ? `${days} day${days > 1 ? 's' : ''} ${hours} hrs ${minutes} mins`
        : `${hours} hrs ${minutes} mins`;

    this.innerHTML = output;
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }
}

customElements.define('exp-delivery-timer', ExpDeliveryTimer);
